<div>
    <app-spare-parts-list></app-spare-parts-list>
</div>
<div>
    <app-spare-parts-form></app-spare-parts-form>
</div>